import React from 'react';
import Icon, { COLORS, ICONS } from '../general-components/icon';
import { getNameOrInitials } from '../../utils/utils';
import { Profile } from '../../stores/reducers/invitations';
import { ConnectedUser } from '../../connection/socket';

interface MyProps {
    profile: Profile | ConnectedUser;
    size?: number;
}

export default function EmptyScreenShare(props: MyProps) {
	const { profile, size } = props;
	return (
        <div className="empty-shot">
            <div className="empty-video screenshare">
                <Icon name={ICONS.SHARE_SCREEN} color={COLORS.WHITE} size={!size ? 76 : size} />
                <div className="name-label">{getNameOrInitials(profile, true)}</div>
            </div>
        </div>
	);
}
